import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { ContentCustom } from '../../../components';
import ProductsSettings from './ProductsSettings';
import EsalesSettings from './EsalesSettings';

const { TabPane } = Tabs;

export const Settings = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get('t') || 'ProductSettings';

  const handleTabChange = (key) => {
    navigate({
      pathname: location.pathname,
      search: `?t=${key}`
    });
  };

  return (
    <>
      <ContentCustom>
        <Tabs activeKey={activeTab} onChange={handleTabChange}>
          <TabPane
            tab={<div>{t('settings.title_ProductSettings')}</div>}
            key="ProductSettings"
          >
            <ProductsSettings />
          </TabPane>
          <TabPane
            tab={<div>{t('settings.title_EsalesSettings')}</div>}
            key="EsalesSettings"
          >
            <EsalesSettings />
          </TabPane>
        </Tabs>
      </ContentCustom>
    </>
  );
};

export default Settings;
